import { render, staticRenderFns } from "./audition.vue?vue&type=template&id=633cf305&"
import script from "./audition.vue?vue&type=script&lang=ts&"
export * from "./audition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports